/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs */

const en__field_enum_csjensblank_weiterbildungsmoeglichkeiten39 = /** @type {(inputs: _Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tips to find opertunities for more specialiced education`)
};

const de__field_enum_csjensblank_weiterbildungsmoeglichkeiten39 = /** @type {(inputs: _Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps zu Weiterbildungsmöglichkeiten`)
};

/**
* | output |
* | --- |
* | "tips to find opertunities for more specialiced education" |
*
* @param {_Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_weiterbildungsmoeglichkeiten39 = /** @type {((inputs?: _Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Weiterbildungsmoeglichkeiten39Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_weiterbildungsmoeglichkeiten39(inputs)
	return de__field_enum_csjensblank_weiterbildungsmoeglichkeiten39(inputs)
});
export { _field_enum_csjensblank_weiterbildungsmoeglichkeiten39 as "_field_enum_CSJENSBLANK_WEITERBILDUNGSMOEGLICHKEITEN" }